const rewardAds = {
  title: 'Reward Ads',
  create: 'Create Reward Ad Campaign',

  stats: {
    total: 'Total Campaigns',
    total_hint: 'All Time',
    active: 'Active',
    active_hint: 'Running Now',
    scheduled: 'Scheduled Campaigns',
    scheduled_hint: 'Starting Soon',
    completed: 'Completed Campaigns',
    completed_hint: 'All time'
  },

  filters: {
    search_placeholder: 'Search campaign by name',
    all_statuses: 'All statuses',
    all_targeting: 'All Targeting',
    all_time: 'All Time',
    status_active: 'Active',
    status_scheduled: 'Scheduled',
    status_completed: 'Completed',
    all_customers: 'All Customers'
  },

  listing: {
    columns: {
      campaign: 'Campaign',
      period: 'Period',
      budget: 'Budget',
      targeting: 'Targeting',
      frequency: 'Frequency',
      status: 'Status'
    },
    empty_title: 'No reward ads yet',
    empty_hint: "Reward ads will appear here once they're created.",
    no_results_title: 'No results found',
    no_results_hint: "Try adjusting your filters to find what you're looking for.",
    selected: '{{total}} row(s) selected.',
    page_of: 'Page {{page}} of {{total}}',
    actions: {
      view_details: 'View Details',
      edit: 'Edit Campaign',
      duplicate: 'Duplicate Campaign',
      view_analytics: 'View Analytics',
      end_campaign: 'End Campaign'
    }
  },

  detail: {
    breadcrumb: 'Reward Ads Detail',
    edit: 'Edit',
    budget: 'BUDGET',
    daily_budget: 'DAILY BUDGET',
    spent: 'SPENT',
    period: 'PERIOD',
    merchant: 'MERCHANT',
    blocked: 'Blocked',
    deletion_requested: 'Deletion requested on {{date}}',

    tabs: {
      overview: 'Overview',
      performance: 'Performance',
      audience: 'Audience',
      location: 'Location',
      devices: 'Devices',
      targeting_schedule: 'Targeting & Schedule',
      creative_repeat: 'Creative & Repeat'
    },

    overview: {
      callback_url: 'Callback URL',
      cta_message: 'Call to Action Message',
      description: 'Description',
      campaign_id: 'Campaign ID',
      created_date: 'Created Date',
      last_updated: 'Last Updated',
      video_asset: 'VIDEO ASSET',
      download: 'Download',
      target_summary: 'TARGET SUMMARY',
      interests: 'Interests',
      location: 'Location',
      ip_targeting: 'IP Targeting',
      schedule_summary: 'SCHEDULE SUMMARY',
      start_date: 'Start Date',
      end_date: 'End Date',
      days_to_display: 'Days to Display',
      hours_to_display: 'Hours to Display',
      frequency: 'Frequency',
      repeat_summary: 'REPEAT SUMMARY',
      days_to_repeat: 'Days to Repeat',
      hours_to_repeat: 'Hours to Repeat'
    },

    performance: {
      views_over_time: 'Views Over Time',
      sourcing_vs_demand: 'Sourcing vs Demand gap',
      conversion_funnel: 'Conversion Funnel',
      conversion_rate: 'Conversion Rate',
      spend_efficiency: 'Spend Efficiency',
      video_metrics: 'Conversion Rate'
    },

    audience: {
      reach_over_time: 'Audience Reach Over Time',
      viewer_frequency_distribution: 'Viewer Frequency Distribution',
      targeting_summary: 'Targeting Summary',
      viewer_type_breakdown: 'Viewer Type Breakdown',
      audience_quality: 'Audience Quality',
      engagement_by_cohort: 'Audience Engagement by Cohort',
      table: {
        cohort: 'Cohort',
        unique_viewers: 'Unique Viewers',
        completion_rate: 'Completion Rate',
        cta_click_rate: 'CTA Click Rate',
        reward_claims: 'Reward Claims'
      }
    },

    location: {
      view_by_location_over_time: 'View By Location Over Time',
      viewers_by_location: 'Viewers By Location',
      targeting_summary: 'Targeting Summary',
      viewer_type_breakdown: 'Viewer Type Breakdown',
      audience_quality: 'Audience Quality'
    },

    devices: {
      device_breakdown: 'Device Breakdown',
      os_breakdown: 'OS Breakdown',
      table: {
        device: 'Device',
        viewers: 'Viewers',
        completion_rate: 'Completion Rate',
        cta_click_rate: 'CTA Click Rate',
        reward_claims: 'Reward Claims'
      }
    },

    targeting_schedule: {
      targeting_title: 'Targeting',
      schedule_title: 'Schedule',
      interests: 'Interests',
      location: 'Location',
      ip_targeting: 'IP Targeting',
      gender: 'Gender',
      marital_status: 'Marital Status',
      age_range: 'Age Range',
      geo_location: 'Geo Location',
      audience_summary: 'Audience Summary',
      audience_summary_text: 'People matching all targeting criteria above. Estimates are based on latest available data and may vary.',
      budget: 'Budget',
      daily_budget: 'Daily Budget',
      start_date: 'Start Date',
      end_date: 'End Date',
      days_to_display: 'Days to Display',
      hours_to_display: 'Hours to Display',
      frequency: 'Frequency',
      campaign_summary_title: 'Campaign Summary',
      estimated_audience: 'Estimated Audience',
      targeted_locations: 'Targeted Locations',
      interests_selected: 'Interests Selected',
      ip_ranges: 'IP Ranges',
      estimated_daily_reach: 'Estimated Daily Reach',
      estimated_daily_impressions: 'Estimated Daily Impressions',
      scheduled_recap_title: 'Scheduled Recap',
      campaign_period: 'Campaign Period'
    },

    creative_repeat: {
      video_asset: 'VIDEO ASSET',
      download: 'Download',
      creative_detail_title: 'Creative Detail',
      title: 'Title',
      cta_message: 'CTA Message',
      description: 'Description',
      callback_url: 'Callback URL',
      asset_status: 'Asset Status',
      repeat_settings_title: 'Repeat Settings',
      days_to_display: 'Days to Display',
      hours_to_repeat: 'Hours to Repeat',
      days_to_repeat_campaign: 'Days to Repeat Campaign',
      delivery_note: 'Delivery Note',
      schedule_title: 'Schedule',
      budget: 'Budget',
      daily_budget: 'Daily Budget',
      start_date: 'Start Date',
      end_date: 'End Date',
      hours_to_display: 'Hours to Display',
      frequency: 'Frequency'
    }
  },

  createFlow: {
    steps: {
      basic_details: 'Basic details',
      targeting: 'Targeting',
      budgeting: 'Budgeting',
      creative_upload: 'Creative Upload',
      review: 'Review & Submit'
    },

    basic: {
      title: 'Basic Details',
      fields: {
        title: { label: 'Title', placeholder: 'e.g. Ecobank New Bank Card', hint: 'A concise title helps you identify this campaign easily' },
        callback_url: { label: 'Callback URL', placeholder: 'https://example.com/callback', hint: "We'll send reward events and user engagement data to this URL" },
        cta_message: { label: 'Call To Action Message', placeholder: 'Check it out', hint: 'This is the message customers will see before they earn the reward' },
        description: { label: 'Description', placeholder: 'Provide more context about the reward and how it works', hint: 'Provide more context about the reward and how it works' }
      }
    },

    targeting: {
      title: 'Targeting',
      interest: { label: 'Interest', placeholder: 'Select interest' },
      location: { label: 'Location', placeholder: 'Select location' },
      ip_targeting: { label: 'IP Targeting', placeholder: 'Add IP range and press Enter' },
      map_label: 'Target Area Preview'
    },

    budgeting: {
      title: 'Budgeting',
      daily_budget: { label: 'Daily Budget', placeholder: 'NGN 0.00', hint: 'The maximum amount to spend per day on this campaign' },
      start_date: 'Start Date',
      end_date: 'End Date',
      days_to_display: 'Days to Display',
      days_to_display_hint: 'Choose which days of the week this ad should run',
      hours_to_display: 'Hours to Display',
      frequency: { label: 'Frequency', placeholder: 'Select frequency' },
      schedules: { label: 'Select Schedule(s)', hint: 'Pick one or more existing schedule slots this ad should run in', loading: 'Loading schedules...', empty: 'No schedules configured yet' },
      max_views: { label: 'Max view per user day', placeholder: 'Select max view per user day' }
    },

    creative: {
      title: 'Creative Upload',
      dropzone_label: 'Click to upload or drag and drop',
      dropzone_hint: 'MP4, MOV, JPG or PNG up to 100MB',
      uploading: 'Uploading...',
      uploaded: 'Uploaded'
    },

    review: {
      title: 'Review & Submit',
      edit: 'Edit',
      schedules_selected: '{{count}} selected',
      sections: {
        basic_details: 'Basic Details',
        targeting: 'Targeting',
        budgeting: 'Budgeting',
        creative_upload: 'Creative Upload'
      },
      fields: {
        title: 'Title',
        callback_url: 'Callback URL',
        cta_message: 'Call To Action Message',
        description: 'Description',
        interest: 'Interest',
        location: 'Location',
        ip_targeting: 'IP Targeting',
        daily_budget: 'Daily Budget',
        start_date: 'Start Date',
        end_date: 'End Date',
        days_to_display: 'Days to Display',
        hours_to_display: 'Hours to Display',
        frequency: 'Frequency',
        schedules: 'Schedules',
        max_views: 'Max view per user day',
        upload: 'Upload',
        size: 'Size'
      }
    },

    summary: {
      targeting_title: 'Targeting Summary',
      budgeting_title: 'Budgeting Summary',
      estimated_audience: 'Estimated Audience',
      people: 'People',
      based_on_targeting: 'Based on your targeting selection',
      interests: 'Interests',
      locations: 'Locations',
      ip_ranges: 'IP Ranges',
      selected_count: '{{count}} Selected',
      daily_budget: 'Daily Budget',
      campaign_duration: 'Campaign Duration',
      total_budget: 'Total Budget',
      est_daily_reach: 'Est. Daily Reach',
      days_count: '{{count}} days',
      estimate_disclaimer: 'Estimates are based on historical data and may vary'
    },

    created_toast: 'Reward ad campaign created successfully',
    submitting: 'Creating...'
  }
}

export default rewardAds
